module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "ladda-button btn",
    class: _vm.classObject,
    attrs: {
      "type": _vm.buttonType,
      "data-style": "slide-left"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.click($event)
      }
    }
  }, [_c('span', {
    staticClass: "ladda-label"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-46bb13ec"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/LaddaButton.vue
// module id = 985
// module chunks = 0